// import lozad from 'lozad'

export default {
	// init() {
	// },
	finalize() {
		let sliderBtnWrap = document.getElementById('slider_btns')

		if (sliderBtnWrap) {
			makeSlider(sliderBtnWrap)
		}

		// let observer = lozad()
		// observer.observe()
	},
}

function makeSlider(sliderBtnWrap) {
	let { Siema } = window
	let sliderBtns = []

	let slider = new Siema({
		duration: 500,
		easing: 'ease',
		onChange: () => {
			let { currentSlide } = slider
			for (let index = 0; index < sliderBtns.length; index++) {
				const btn = sliderBtns[index]
				if (index === currentSlide) {
					btn.classList.add('active')
				} else {
					btn.classList.remove('active')
				}
			}
		},
	})

	// Add a function that generates pagination to prototype
	Siema.prototype.addPagination = function () {
		for (let i = 0; i < this.innerElements.length; i++) {
			const btn = document.createElement('button')
			if (i === 0) {
				btn.classList.add('active')
			}
			btn.innerHTML = `<span class="sr-only">slide ${i + 1}</span>`
			btn.addEventListener('click', () => {
				this.goTo(i)
			})
			sliderBtnWrap.appendChild(btn)
			sliderBtns.push(btn)
		}
	}

	$('#prev').on('click', () => slider.prev())
	$('#next').on('click', () => slider.next())

	// Trigger pagination creator
	slider.addPagination()
}
